import { Helmet } from "react-helmet-async";

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LocalBusiness", "TaxiService"],
      "@id": "https://limassolairporttaxi.com/#business",
      name: "Limassol Airport Taxi",
      url: "https://limassolairporttaxi.com/",
      telephone: "+35796613191",
      email: "info@limassolairporttaxi.com",
      description:
        "Limassol Airport Taxi provides reliable 24/7 airport transfers and taxi services across Cyprus.",
      serviceType: "Airport Transfers",
      areaServed: {
        "@type": "Country",
        name: "Cyprus",
      },
      serviceArea: [
        {
          "@type": "City",
          name: "Limassol",
        },
        {
          "@type": "Place",
          name: "Larnaca Airport",
        },
        {
          "@type": "Place",
          name: "Paphos Airport",
        },
        {
          "@type": "City",
          name: "Nicosia",
        },
        {
          "@type": "City",
          name: "Ayia Napa",
        },
        {
          "@type": "City",
          name: "Protaras",
        },
      ],
      openingHours: "Mo-Su 00:00-23:59",
    },
  ],
};

function SeoSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export default SeoSchema;
